/**
 * Очередь отложенных публикаций (бэкенд `/api/scheduler`).
 * Рилс попадает в очередь через `meta.scheduledAt` при отправке джобы рендера,
 * пост — этим клиентом, уже после создания записи поста.
 */

import { backendFetch } from './client';

export type ScheduledStatus = 'pending' | 'running' | 'done' | 'failed' | 'cancelled';

export interface ScheduledItem {
  id: string;
  kind: 'reel' | 'post';
  run_at: string;
  status: ScheduledStatus;
  attempts: number;
  last_error: string | null;
  label: string | null;
  created_at: string;
}

async function asJson<T>(res: Response, fallback: string): Promise<T> {
  const body = (await res.json().catch(() => ({}))) as T & { error?: string };
  if (!res.ok) throw new Error(body.error ?? fallback);
  return body;
}

export async function schedulePost(input: {
  postId: string;
  accountId?: string;
  runAt: string;
  label?: string;
  /** Выложить сторис вместе с постом, когда подойдёт время. */
  duplicateToStory?: boolean;
}): Promise<ScheduledItem> {
  const res = await backendFetch('/api/scheduler/posts', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  return asJson<ScheduledItem>(res, 'Не удалось запланировать публикацию');
}

export async function listScheduled(status?: ScheduledStatus): Promise<ScheduledItem[]> {
  const res = await backendFetch(`/api/scheduler${status ? `?status=${status}` : ''}`);
  const body = await asJson<{ items: ScheduledItem[] }>(res, 'Не удалось загрузить очередь');
  return body.items ?? [];
}

export async function cancelScheduled(id: string): Promise<void> {
  const res = await backendFetch(`/api/scheduler/${id}`, { method: 'DELETE' });
  await asJson<{ success: boolean }>(res, 'Не удалось отменить публикацию');
}
